/**
 * A list of statuses that will be used to indicate whether the downtime of a service, as well as the resultant status of the consuming application.
 */
export default {
  down: 'down',
  downtimeApproaching: 'downtimeApproaching',
  ok: 'ok',
};
